import { render, staticRenderFns } from "./ToolComparation.vue?vue&type=template&id=0327b9d5&scoped=true"
import script from "./ToolComparation.vue?vue&type=script&lang=js"
export * from "./ToolComparation.vue?vue&type=script&lang=js"
import style0 from "./ToolComparation.vue?vue&type=style&index=0&id=0327b9d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327b9d5",
  null
  
)

export default component.exports